<template>
  <div class="market__layer">
    <div class="market-serch">
      <div class="market-serch-date" v-if="isShow">
        <span class="market-serch-date-titles">财经日历</span>

      </div>
      <div class="market-serch-date" v-else>
        <span class="market-serch-date-title">公布日期查询</span>
        <div class="market-serch-date-picker">
          <el-date-picker v-model="datePicker" type="date" suffix-icon="el-icon-date" placeholder="选择查询日期"
            format="yyyy-MM-dd" value-format="yyyy-MM-dd" prefix-icon="prefix-icon-class" @change="selectPicker"
            :clearable="false" style="width: 180px;">
          </el-date-picker>
          <img src="@/assets/imgs/icon/date-icon.png" alt="">
        </div>
        <div class="market-serch-filter">
          <!-- <div class="market-serch-filter-icon">
            <span>筛选</span>
            <img src="@/assets/imgs/icon/filter-icon.png" alt="">
          </div> -->
          <ul class="market-serch-filter-box">
            <li>
              <span>状态</span>
              <el-row>
                <el-button @click="clickBtn(1,$event)" :class="status == 1 ? 'statusBtn' : '' " type="info"
                  size="small">全部</el-button>
                <el-button @click="clickBtn(2,$event)" :class="status == 2 ? 'statusBtn' : '' " type="info"
                  size="small">今日</el-button>
                <el-button @click="clickBtn(3,$event)" :class="status == 3 ? 'statusBtn' : '' " type="info"
                  size="small">未知</el-button>
                <el-button @click="clickBtn(4,$event)" :class="status == 4 ? 'statusBtn' : '' " type="info"
                  size="small">重要</el-button>
              </el-row>
            </li>
            <li>按照国家/地区条件查找</li>
            <li>
              <p>美洲</p>
              <div>
                <el-row>
                  <el-button @click="clickBtn2(1,$event)" :class="local == 1 ? 'statusBtn' : '' " type="info"
                    size="small">全部</el-button>
                </el-row>
              </div>
            </li>
            <li>
              <p>欧元</p>
              <div>
                <el-row>
                  <el-button @click="clickBtn2(2,$event)" :class="local == 2 ? 'statusBtn' : '' " type="info"
                    size="small">德国</el-button>
                  <el-button @click="clickBtn2(3,$event)" :class="local == 3 ? 'statusBtn' : '' " type="info"
                    size="small">英国</el-button>
                  <el-button @click="clickBtn2(4,$event)" :class="local == 4 ? 'statusBtn' : '' " type="info"
                    size="small">法国</el-button>
                  <el-button @click="clickBtn2(5,$event)" :class="local == 5 ? 'statusBtn' : '' " type="info"
                    size="small">瑞士</el-button>
                </el-row>
                <el-row>
                  <el-button @click="clickBtn2(6,$event)" :class="local == 6 ? 'statusBtn' : '' " type="info"
                    size="small">意大利</el-button>
                  <el-button @click="clickBtn2(7,$event)" :class="local == 7 ? 'statusBtn' : '' " type="info"
                    size="small">西班牙</el-button>
                </el-row>
              </div>
            </li>
            <li>
              <p>美洲</p>
              <div>
                <el-row>
                  <el-button @click="clickBtn2(8,$event)" :class="local == 8 ? 'statusBtn' : '' " type="info"
                    size="small">意大利</el-button>
                  <el-button @click="clickBtn2(9,$event)" :class="local == 9 ? 'statusBtn' : '' " type="info"
                    size="small">西班牙</el-button>
                </el-row>
              </div>
            </li>
            <li>
              <p>亚洲</p>
              <div>
                <el-row>
                  <el-button @click="clickBtn2(10,$event)" :class="local == 10 ? 'statusBtn' : '' " type="info"
                    size="small">中国</el-button>
                  <el-button @click="clickBtn2(11,$event)" :class="local == 11 ? 'statusBtn' : '' " type="info"
                    size="small">日本</el-button>
                  <el-button @click="clickBtn2(12,$event)" :class="local == 12 ? 'statusBtn' : '' " type="info"
                    size="small">韩国</el-button>
                  <el-button @click="clickBtn2(13,$event)" :class="local == 13 ? 'statusBtn' : '' " type="info"
                    size="small">印度</el-button>
                </el-row>
                <el-row>
                  <el-button @click="clickBtn2(14,$event)" :class="local == 14 ? 'statusBtn' : '' " type="info"
                    size="small">香港</el-button>
                  <el-button @click="clickBtn2(15,$event)" :class="local == 15 ? 'statusBtn' : '' " type="info"
                    size="small">台湾</el-button>
                  <el-button @click="clickBtn2(16,$event)" :class="local == 16 ? 'statusBtn' : '' " type="info"
                    size="small">新加坡</el-button>
                </el-row>
              </div>
            </li>
            <li>
              <p>澳洲</p>
              <div>
                <el-row>
                  <el-button @click="clickBtn2(17,$event)" :class="local == 17 ? 'statusBtn' : '' " type="info"
                    size="small">澳大利亚</el-button>
                  <el-button @click="clickBtn2(18,$event)" :class="local == 18 ? 'statusBtn' : '' " type="info"
                    size="small">意大利</el-button>
                  <el-button @click="clickBtn2(19,$event)" :class="local == 19 ? 'statusBtn' : '' " type="info"
                    size="small">西班牙</el-button>
                </el-row>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div class="market-serch-week">
        <div class="market-serch-title">财经日历</div>
        <span v-for="(item, index) in weekDate" :class="`${controlDiv === index && 'market-serch-week-acitve'}`"
          :key="'week-' + index" @click="handleWeek(item, index)">
          {{ weekStr[index] }}
        </span>
      </div>
    </div>
    <div class="market-table">
      <el-table :data="tableData" v-loading='loading' style="width: 100%"
        :header-cell-style="{textAlign: 'center',color:'#999999',height:'65px'}" :row-style="{height:'65px'}"
        :cell-style="{ textAlign: 'center',color:'#959595'}">
        <el-table-column prop="time_show" label="时间" />
        <el-table-column prop="country" label="国/地区">
          <!-- <template slot-scope="scope">
            <img :src="scope.row.countryUrl" alt="">
          </template> -->
        </el-table-column>
        <el-table-column prop="title" label="事件名称" :show-overflow-tooltip="true" width="250" />
        <el-table-column prop="star" label="重要性">
          <template slot-scope="scope">
            <i v-for="t in scope.row.star" :key="'active-' + t" style="color:#FA2314"
              class="iconfont icon-shoucang"></i>
            <i v-for="t in (5 - scope.row.star)" :key="'un-' + t" style="color:#E4E4E7"
              class="iconfont icon-shoucang"></i>
          </template>
        </el-table-column>
        <el-table-column prop="previous" label="前值">
          <template slot-scope="scope">
            <span>{{ scope.row.previous || '--'}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="consensus" label="预测值">
          <template slot-scope="scope">
            <span>{{ scope.row.consensus || '--'}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="actual" label="公布值">
          <template slot-scope="scope">
            <span>{{ scope.row.actual || '未公布'}}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="status_name" label="影响"> -->
          <!-- <template slot-scope="scope">
            <span v-if="scope.row.influence =='' || scope.row.influence =='未公布' ">--</span>
            <span style="color:#ff9106" v-if="scope.row.influence =='影响较小'">{{scope.row.influence}}</span>
            <span style="color:#FA2314" v-if="scope.row.influence =='利多 金银'">{{scope.row.influence}}</span>
            <span style="color:#11C771" v-if="scope.row.influence =='利空 金银'">{{scope.row.influence}}</span>
          </template> -->
        <!-- </el-table-column> -->
      </el-table>
      <div v-if="controlBtn" class="market-table-more">
        <span @click="moreCalendar">加载更多</span>
      </div>
    </div>
  </div>
</template>

<script>
import { postCmsSystemRelay} from '@/apis/transfer';
import { ViewListWithHoliday } from '@/apis/common';
export default {
  props:{
    isShow:{
      type:Boolean,
      default:false
    }
  },
  data(){
    return{
      // 控制leftTop
      controlDiv:1,
      // 表格数据
      tableData:[],
      // 该日所在周的所有日期
      weekDate:[],
      weekStr: ['周一', '周二', '周三', '周四', '周五', '周六', '周天'],
      // 筛选的日期
      datePicker:'',
      // 状态筛选按钮
      status:1,
      // 地区筛选按钮
      local:1,
      loading:true,
      // 控制是否显示btn
      controlBtn:false,
      // 调取参数的接口
      attr:{
        date:(new Date()).Format('yyyyMMdd'),
       
      }
    }
  },
  created(){
    // 默认日期选择框为今天日期
    this.datePicker = (new Date()).Format('yyyy-MM-dd');
    // 通过默认日期查询出该日所在周的所有日期，以及控制controlDiv的显示
    this.selectPicker(this.datePicker);
  },
  methods:{
    // 获取财经日历方法
    initViewList(attr,type){
     
      ViewListWithHoliday(attr).then(res => {
        console.log(res);
        this.controlBtn = false;
        this.loading = false;
        let data = res.result.calendarLst.filter((item) => {
          if (item.previous !== '' && !item.title.includes('公布下一条数据')) {
            return item;
          }
        });
        if (type == 0) {
          this.tableData = data.splice(0, 7);
          if (data.length > 7) {
            this.controlBtn = true;
          }
        } else {
          this.tableData = data;
          this.controlBtn = false;
        }
        
      }).catch(() => {
        this.tableData = [
          
        ];
        this.loading = false;
        this.controlBtn = false;
      })
    },
    // 按状态筛选
    clickBtn(key,event){
      this.loading = true;
      this.attr.country = '';
      if(event.target.innerHTML.length>5){
        console.log((event.target.innerHTML.split('</')[0]).split('n>')[1]);
        switch((event.target.innerHTML.split('</')[0]).split('n>')[1]){
          case '全部':
            this.attr.importance = 0;
            break
          case '今日':
            this.attr.importance = 0;
            break
          case '未知':
            this.attr.importance = 1;
            break
          case '重要':
            this.attr.importance = 3;
            break
        }
        this.initViewList(this.attr,0);
      }else{
        switch(event.target.innerHTML){
          case '全部':
            this.attr.importance = 0;
            break
          case '今日':
            this.attr.importance = 0;
            break
          case '未知':
            this.attr.importance = 1;
            break
          case '重要':
            this.attr.importance = 3;
            break
        }
        this.initViewList(this.attr,0);
      }
      this.status = key;
    },
    // 按地区筛选
    clickBtn2(key,event){
      this.loading = true;
      this.attr.importance = 0;
      if(event.target.innerHTML.length>5){
        this.attr.country = (event.target.innerHTML.split('</')[0]).split('n>')[1];
      }else{
        if(event.target.innerHTML == '全部'){
          this.attr.country = '';
        }else{
          this.attr.country = event.target.innerHTML;
        }
      }
      this.local = key;
      this.initViewList(this.attr,0);
    },
    // 根据某一天日期，获取该日所在周的所有日期
    getWeek(input_day) {
      // 一天里一共的毫秒数
      let oneDayTime = 1000 * 60 * 60 * 24 
      let today = new Date(input_day)
      // 若那一天是周末时，则强制赋值为7
      let todayDay = today.getDay() || 7 
      let startDate = new Date(
        today.getTime() - oneDayTime * (todayDay - 1)
      )
      for(let i = 0; i < 7; i++){
        let temp = new Date(startDate.getTime() + i * oneDayTime)
        let year = temp.getFullYear();
        let month = temp.getMonth() + 1;
        if(month<10){
          month = '0'+month;
        }
        let day = temp.getDate();
        if(day<10){
          day = '0'+day;
        }
        this.weekDate[i] = `${year}-${month}-${day}` 
      }
      return this.weekDate;
    },
    // 根据日期判断与weekdata的第几个元素相等
    craigJudge(key){
      for(let i in this.weekDate){
        if(key == this.weekDate[i]){
          return i;
        }
      }
    },
    // 选择日期
    selectPicker(key){
      if(!key) { return }
      this.loading = true;
      // this.attr.country = '';
      // this.attr.importance = 0;
      this.getWeek(key);
      this.controlDiv = Number(this.craigJudge(key));
      // 去掉key中的-
      this.attr.date = key.replace(/-/g,'');
      this.initViewList(this.attr,0);
    },
    // 获取更多数据
    moreCalendar(){
      this.loading = true;
      this.attr.date = this.datePicker.replace(/-/g,'');
      this.initViewList(this.attr,1);
    },
    handleWeek(item, index) {
      this.datePicker = item;
      this.controlDiv = index;
      this.loading = true;
      // this.attr.country = '';
      // this.attr.importance = 0;
      // 截取点击后的具体时间
      this.attr.date = item.replace(/-/g,"");
      this.initViewList(this.attr,0);
    },
  }
}
</script>

<style lang="less" scoped>
  .market__layer{
    background: #FFFFFF;
    padding: 40px;

    .market-serch {
      display: flex;
      align-items: center;
      justify-content: space-between;

      &-date {
        display: block;
        display: flex;
        align-items: center;

        &-title {
          color: #0F0F11;
          margin-right: 15px;
          font-weight: 700;
        }
        &-titles{
          color: #0F0F11;
          font-size: 24px;
          line-height: 32px;
          font-weight: 700;
        }
        /deep/ .el-input__suffix-inner{
          font-size: 22px;
          margin-right: 8px;
          .el-icon-date{
            color: #DB2C23;
          }
          .el-range__close-icon{
            display: none;
          }
        }

        &-picker {
          display: flex;
          justify-content: center;
          align-items: center;
          position: relative;
          img {
            position: absolute;
            top: 50%;
            right: 0px;
            transform: translate(-50%, -50%);
          }
        }

        .market-serch-filter {
          margin-left: 30px;
          position: relative;
          

          &:hover {
            .market-serch-filter-box {
              display: block;
            }
          }
          
          &-icon {
            cursor: pointer;
            display: flex;
            align-items: center;
           
            span{
              margin-right: 10px;
              font-weight: 700;
              color: #000;
            }
            i{
              font-size: 22px;
              color: #da3e4c;
            }
          }

          &-box {
            list-style: none;
            width: 510px;
            height: 550px;
            position: absolute;
            top: 10px;
            left: -57px;
            background:url(../../../static/market/juxing.png) no-repeat;
            background-size: cover;
            z-index: 999;
            display: none;
            box-sizing: border-box;
            padding: 50px 50px;
            li{
              font-size: 18px;
              font-weight: 550;
              display: flex;
              justify-content: flex-start;
              align-items: flex-start;
              margin-bottom: 10px;
              span{
                color: #333333;
                font-size: 18px;
                font-weight: 550;
              }
              p{
                color: #333333;
                font-size: 18px;
                font-weight: 550;
                margin-right: 10px;
              }
              .el-row{
                margin-bottom: 10px;
                .statusBtn{
                  background-color: #db3d4c;
                  border-color: #db3d4c;
                }
              }
            }
            li:nth-child(1){
              flex-direction: column;
              span{
                margin-bottom: 10px;
              }
            }
          }
          
        }
      }
      &-week {
        span {
          width: 88px;
          line-height: 40px;
          text-align: center;
          color: #93939F;
          cursor: pointer;
          display: inline-block;
          margin-left: 1px;
        }
        &-acitve, span:hover {
          background: #FA2314;
          color: #FFFFFF !important;
          border-radius: 6px;
        }
      }
      &-title{
        display: none;
        font-size: 16px;
        line-height: 22px;
        font-weight: 600;
        margin: 16px 0;
      }
    }

    .market-table {
      height: auto;
      margin-top: 20px;

      img{
        width: 42px;
      }
      &-more {
        text-align: center;
        margin-top: 50px;
        span {
          cursor: pointer;
          color: #FA2314;
          text-decoration: underline;
        }
      }
    }
  }
  @media screen and (max-width: 500px) {
   .market__layer{
    padding: 0 20px;
    .market-serch {
      &-date {
        display: none;
      }
       &-week {
        white-space: nowrap;
        overflow: hidden;
        overflow-x: scroll;
        span{
          width: 46px;
          font-size: 12px;
          line-height: 32px;
        }
       }
       &-title{
        display: block;
       }
    }
    .market-table {
      &-more{
        margin-bottom: 50px;
        span{
          font-size: 12px;
        }
      }
    }
   }
  }
     // -------------------------小屏幕适配-------------------
     @media screen and (min-width: 1264px) and (max-width: 1724px) {
      .market__layer {
          background: #FFFFFF;
          padding: 40px;
      
          .market-serch {
            display: flex;
            align-items: center;
            justify-content: space-between;
      
            &-date {
              display: block;
              display: flex;
              align-items: center;
      
              &-title {
                color: #0F0F11;
                margin-right: 15px;
                font-weight: 700;
              }
      
              &-titles {
                color: #0F0F11;
                font-size: 24px;
                line-height: 32px;
                font-weight: 700;
              }
      
              /deep/ .el-input__suffix-inner {
                font-size: 22px;
                margin-right: 8px;
      
                .el-icon-date {
                  color: #DB2C23;
                }
      
                .el-range__close-icon {
                  display: none;
                }
              }
      
              &-picker {
                display: flex;
                justify-content: center;
                align-items: center;
                position: relative;
      
                img {
                  position: absolute;
                  top: 50%;
                  right: 0px;
                  transform: translate(-50%, -50%);
                }
              }
      
              .market-serch-filter {
                margin-left: 30px;
                position: relative;
      
      
                &:hover {
                  .market-serch-filter-box {
                    display: block;
                  }
                }
      
                &-icon {
                  cursor: pointer;
                  display: flex;
                  align-items: center;
      
                  span {
                    margin-right: 10px;
                    font-weight: 700;
                    color: #000;
                  }
      
                  i {
                    font-size: 22px;
                    color: #da3e4c;
                  }
                }
      
                &-box {
                  list-style: none;
                  width: 510px;
                  height: 550px;
                  position: absolute;
                  top: 10px;
                  left: -57px;
                  background: url(../../../static/market/juxing.png) no-repeat;
                  background-size: cover;
                  z-index: 999;
                  display: none;
                  box-sizing: border-box;
                  padding: 50px 50px;
      
                  li {
                    font-size: 18px;
                    font-weight: 550;
                    display: flex;
                    justify-content: flex-start;
                    align-items: flex-start;
                    margin-bottom: 10px;
      
                    span {
                      color: #333333;
                      font-size: 18px;
                      font-weight: 550;
                    }
      
                    p {
                      color: #333333;
                      font-size: 18px;
                      font-weight: 550;
                      margin-right: 10px;
                    }
      
                    .el-row {
                      margin-bottom: 10px;
      
                      .statusBtn {
                        background-color: #db3d4c;
                        border-color: #db3d4c;
                      }
                    }
                  }
      
                  li:nth-child(1) {
                    flex-direction: column;
      
                    span {
                      margin-bottom: 10px;
                    }
                  }
                }
      
              }
            }
      
            &-week {
              span {
                width: 68px;
                line-height: 40px;
                text-align: center;
                color: #93939F;
                cursor: pointer;
                display: inline-block;
                margin-left: 1px;
              }
      
              &-acitve,
              span:hover {
                background: #FA2314;
                color: #FFFFFF !important;
                border-radius: 6px;
              }
            }
      
            &-title {
              display: none;
              font-size: 16px;
              line-height: 22px;
              font-weight: 600;
              margin: 16px 0;
            }
          }
      
          .market-table {
            height: auto;
            margin-top: 20px;
      
            img {
              width: 42px;
            }
      
            &-more {
              text-align: center;
              margin-top: 50px;
      
              span {
                cursor: pointer;
                color: #FA2314;
                text-decoration: underline;
              }
            }
          }
        }
     }
</style>